import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import Dashboard from "@/views/module/dashboard/dashboard.vue";

//Settings Management
import holidaySetup from "@/views/module/attendance/settingsManagement/holidaySetup.vue";
import weekendSetup from "@/views/module/attendance/settingsManagement/weekendSetup.vue";
import shiftSetup from "@/views/module/attendance/settingsManagement/shiftSetup.vue";
import employeeShiftMapping from "@/views/module/attendance/settingsManagement/employeeShiftMapping.vue";
import employeeWeekendSetup from "@/views/module/attendance/settingsManagement/employeeWeekendSetup.vue";

//Attendance Management
import addManualAttendance from "@/views/module/attendance/manualEntry/addManualAttendance.vue";

//Reports Management
import attendanceSummaryReport from "@/views/module/attendance/reports/attendanceSummaryReport.vue";
import employeeDailyAttendanceSheet from "@/views/module/attendance/reports/employeeDailyAttendanceSheet.vue";
import attendanceRegisterReport from "@/views/module/attendance/reports/attendanceRegisterReport.vue";
import shiftWiseAttendanceReport from "@/views/module/attendance/reports/shiftWiseAttendanceReport.vue";
import missingPunchReconciliationReport from "@/views/module/attendance/reports/missingPunchReconciliationReport.vue";
import workforceAvailabilityReport from "@/views/module/attendance/reports/workforceAvailabilityReport.vue";
import attendanceLedgerReport from "@/views/module/attendance/reports/attendanceLedgerReport.vue";
import departmentPerformanceDashboard from "@/views/module/attendance/reports/departmentPerformanceDashboard.vue";
import overtimeReport from "@/views/module/attendance/reports/overtimeReport.vue";
import lateEarlyReport from "@/views/module/attendance/reports/lateEarlyReport.vue";
import absentReport from "@/views/module/attendance/reports/absentReport.vue";
import attendanceReconciliationSetup from "@/views/module/attendance/attendanceReconciliation/attendanceReconciliationSetup.vue";
import attendanceReconciliationRecords from "@/views/module/attendance/attendanceReconciliation/attendanceReconciliationRecords.vue";
import attendanceUpload from "@/views/module/attendance/manualEntry/attendanceUpload.vue";

// Roster
import rosterCreate from "@/views/module/attendance/roster/rosterCreate.vue";
import rosterRecord from "@/views/module/attendance/roster/rosterRecord.vue";
import rosterView from "@/views/module/attendance/roster/rosterView.vue";

export default [
    {
    path: "/attendance",    
    name: "attendance",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Attendance Management",
    },
        children: [
            {
                path: "dashboard",
                meta: {
                    breadcrumb: ["Dashboard"],
                },
                component: Dashboard,
            },

            // Settings Management
            {
                path: "shift",
                name: "shift",  
                meta: {
                    breadcrumb: ["Shift Setup"],
                },
                component: shiftSetup,
            },
            {
                path: "employee-shift-mapping",
                name: "employee-shift-mapping",
                meta: {
                    breadcrumb: ["Employee & Shift Mapping"],
                },
                component: employeeShiftMapping,
            },
            {
                path: "weekend",
                name: "weekend",  
                meta: {
                    breadcrumb: ["Weekend Setup"],
                },
                component: weekendSetup,
            },
            {
                path: "employee-wise-weekend",
                name: "employee-weekend",  
                meta: {
                    breadcrumb: ["Employee Weekend Setup"],
                },
                component: employeeWeekendSetup,
            },
            {
                path: "holiday",
                name: "holiday",
                meta: {
                    breadcrumb: ["Add Holiday"],
                },
                component: holidaySetup,    
            },

            //Attendance Management
            {
                path: "manual-entry",
                name: "manual-attendance-entry",
                meta: {
                    breadcrumb: ["Manual Attendance Entry"],
                },
                component: addManualAttendance,    
            },
            {
                path: "attendance-upload",
                name: "attendance-upload",
                meta: {
                    breadcrumb: ["Attendance Upload"],
                },
                component: attendanceUpload,    
            },
            
            //Attendance Reconciliation Management
            {
                path: "reconciliation-setup",
                name: "reconciliation-setup",
                meta: {
                    breadcrumb: ["Reconciliation Setup"],
                },
                component: attendanceReconciliationSetup,    
            },
            {
                path: "reconciliation-records",
                name: "reconciliation-records",
                meta: {
                    breadcrumb: ["Reconciliation Records"],
                },
                component: attendanceReconciliationRecords,    
            },

            {
                path: "employee-roster-add/:id?",
                name: "employee-roster-add",
                meta: {
                    breadcrumb: ["Roster"],
                },
                component: rosterCreate,    
            },
            {
                path: "employee-roster-records",
                name: "employee-roster-records",
                meta: {
                    breadcrumb: ["Reconciliation Records"],
                },
                component: rosterRecord,    
            },
            {
                path: "employee-roster-view/:id",
                name: "employee-roster-view",
                meta: {
                    breadcrumb: ["Reconciliation View"],
                },
                component: rosterView,    
            },
            
            //Reports Management
            {
                path: "daily-attendance-summary-report",
                name: "attendance-summary-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Daily Summary"],
                },
                component: attendanceSummaryReport,
            },
            {
                path: "employee-daily-attendance-sheet",
                name: "employee-daily-attendance-sheet",
                meta: {
                    breadcrumb: ["Attendance Reports", "Employee Daily Sheet"],
                },
                component: employeeDailyAttendanceSheet,
            },
            {
                path: "monthly-attendance-register-payroll-report",
                name: "monthly-attendance-register-payroll-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Monthly Attendance Register"],
                },
                component: attendanceRegisterReport,
            },
            {
                path: "shift-wise-attendance-report",
                name: "shift-wise-attendance-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Shift-Wise Attendance"],
                },
                component: shiftWiseAttendanceReport,
            },
            {
                path: "missing-punch-reconciliation-report",
                name: "missing-punch-reconciliation-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Missing Punch/Reconciliation"],
                },
                component: missingPunchReconciliationReport,
            },
            {
                path: "workforce-availability-report",
                name: "workforce-availability-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Workforce Availability"],
                },
                component: workforceAvailabilityReport,
            },
            {
                path: "attendance-ledger",
                name: "attendance-ledger",
                meta: {
                    breadcrumb: ["Attendance Reports", "Muster Roll / Attendance Ledger"],
                },
                component: attendanceLedgerReport,
            },
            {
                path: "department-performance-attendance-dashboard",
                name: "department-performance-attendance-dashboard",
                meta: {
                    breadcrumb: ["Attendance Reports", "Department Performance Dashboard"],
                },
                component: departmentPerformanceDashboard,
            },
            {
                path: "overtime-report",
                name: "overtime-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Overtime"],
                },
                component: overtimeReport,
            },
            {
                path: "late-early-leave-report",
                name: "late-early-leave-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Late & Early Leave"],
                },
                component: lateEarlyReport,
            },
            {
                path: "absent-report",
                name: "absent-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Absent"],
                },
                component: absentReport,
            }
        ],
    },
];
